import type { ReactNode } from 'react';

export const symbol_bucket_check: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-120q-26.35 0-45.68-16.5Q195-153 191-179l-66-462q-2-14 6.98-24 8.97-10 23.02-10h88v-105q0-24.75 17.63-42.38Q278.25-840 303-840h355q24.75 0 42.38 17.62Q718-804.75 718-780v105h88q13.71 0 22.86 10 9.14 10 7.14 24l-66 462q-4 26-23.5 42.5T701-120H260Zm-71-495 63 435h458.12L772-615H189Zm248 240-38-37q-9-8-21-8.5t-21 8.5q-9 9-9 21t9 21l59 59q8.8 9 20.9 9 12.1 0 21.1-9l146-146q9-9 9.5-21.5t-8.71-21.5q-9.22-9-21.5-9-12.29 0-21.29 9L437-375ZM303-675h355v-105H303v105Zm178 277Z"
		/>
	</svg>
);
